module.exports = __webpack_public_path__ + "img/greenflash.833e19d7.svg";